import { render, staticRenderFns } from "./DataNiaoChangGui.vue?vue&type=template&id=e6b6ad64&"
import script from "./DataNiaoChangGui.vue?vue&type=script&lang=js&"
export * from "./DataNiaoChangGui.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports